////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { isNull } from 'lodash'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import ArticleDatePicker from '../ArticleDatePicker'
import { articleLifeManagerActionCreators } from '../../../../../store/actions'

/////////STYLED/////////
const AddStopDepositWrapper = styled.div``
/////////STYLED/////////
// [63]_c): ADD STOP DEPOSIT

const AddStopDeposit = (props) => {
	const match = useRouteMatch()

	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [dateLimit, setDateToModify] = useState(new Date())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeDate = (date) => {
		setDateToModify(date)
	}

	const handleValidate = () => {
		let testDateToModify = dateLimit.toString().split(' ').splice(0, 4)
		let testCurrentDate = moment().toDate().toString().split(' ').splice(0, 4)
		if (testDateToModify.join('') === testCurrentDate.join('')) {
			actionsArticleLifeManager.postAddStopDeposit(match.params.id, 'AddStopDeposit', moment().add(5, 'minutes').toDate())
		} else {
			actionsArticleLifeManager.postAddStopDeposit(match.params.id, 'AddStopDeposit', dateLimit)
		}
		handleCloseDatePicker()
	}

	const handleCloseDatePicker = () => {
		props.addStopDeposit.close()
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////
	useEffect(() => {
		if (isNull(props.addStopDeposit?.item?.dateLimit))
			if (props.addStopDeposit.show) {
				handleChangeDate(new Date())
			}
	}, [props.addStopDeposit.show])

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.addStopDeposit.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<AddStopDepositWrapper>
			<ArticleDatePicker
				showModal={props.addStopDeposit.show}
				date={dateLimit}
				handleValidate={handleValidate}
				handleClose={handleCloseDatePicker}
				handleChangeDate={handleChangeDate}
				title={translations['modal__itemRef__timeline_action_consignment_endDate_edit_title']}
			/>
		</AddStopDepositWrapper>
	)
}

AddStopDeposit.propTypes = {}

AddStopDeposit.defaultPropTypes = {}

export default AddStopDeposit
